import type { ReactNode } from "react";
import { Eye } from "lucide-react";
import { EmptyState } from "@/components/empty-state";
import { Page } from "@/components/layout/page";
import { useProjectAccess } from "@/lib/project-access";

/**
 * Route guard for pages that exist only to change the project (discover
 * sources, bootstrap, start a run, edit a scenario). Viewers get a short
 * explanation instead of a form the API would refuse. While the role is
 * still loading nothing renders, so editors never see the notice flash.
 */
export function EditorOnlyPage({
  title,
  task,
  back,
  children,
}: {
  title: string;
  /** What an editor does here, completing "Ask an editor to …". */
  task: string;
  back?: { to: string; label: string };
  children: ReactNode;
}) {
  const { canEdit, isViewer } = useProjectAccess();
  if (canEdit) return <>{children}</>;
  if (!isViewer) return null;
  return (
    <Page title={title} back={back}>
      <EmptyState
        icon={Eye}
        title="You can view this project"
        description={`Changes need editor access. Ask an editor to ${task}.`}
      />
    </Page>
  );
}
